import API_MAPS_SERVICES from "../modules/API/api_services_maps";
import SETCOORDS from "../modules/API/set_coords";
SETCOORDS();
/*

    Summary
        0 - Functions
        1 - Initial Config
        2 - Init Map


*/

/*---------------------- 0 - Functions -------------------*/
function getAddressesRepresentatives() {
    const mainDivId = '#page-maps-representative';

    let addressesObj = $.ajax({
        type: "POST",
        url: $(mainDivId).attr('adressesRoute'),
        data: "",
        dataType: "json",
        headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        }
    }).done(() => {
        const allAddress = addressesObj.responseJSON;
        const idForms = '#search-representatives';
        const mapId = 'map--representatives';
        const type = 'representatives';
        const pathMarkerRepresentatives = document.getElementById('pin-markerServices').dataset.image;
        const messageRefence = 'os(as) representantes';
        const messageNotFound = 'Não encontramos representantes próximos a você, iremos filtrar aonde você encontrará o representante mais próximo!';


        API_MAPS_SERVICES(
            allAddress, 
            mapId, idForms,
            pathMarkerRepresentatives, 
            type, 
            messageRefence, messageNotFound,
            mainDivId
        );
    });
}

/*---------------------- 1 - Initial Config -------------------*/
const socialIcons = document.getElementById('component--social-icons')
socialIcons.style.display = 'none'

const header = document.querySelector('header')
header.classList.add("maps-page")

const footer = document.querySelector('footer')
footer.classList.add("maps-page")

document.documentElement.style.setProperty('--zoom', 1);

/*----------------------  2 - Init Map -------------------*/
window.onload = ()=>{
    getAddressesRepresentatives()
}
